import React from 'react';
import {useProductSearchStore} from "../../features/productSearch/model/store";
import FilterNotResult from "../../features/productSearch/ui/filters/not-result/FilterNotResult";
import {utilsTypeof} from "../../shared/utils/utilsTypeof";
import ProductFilters from "../../features/productSearch/ui/filters/ProductFilters";
import ProductFilterSelected from "../../features/productSearch/ui/filters/ProductFilterSelected";
import {useFilterHandler} from "../../features/productSearch/model/useFilterHandler";
import styled from "styled-components";
import filterCheckboxList from "../../features/productSearch/ui/filters/filter-renderer/FilterCheckboxList";
import {GLOBAL_STYLE_CONFIG} from "../../app/styles/GlobalStyles";

const StyledSearchFilterWidget = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
`
/**
 * Компонент SearchFilterWidget
 *
 * Отвечает за отображение блока фильтров и выбранных фильтров в виде тегов.
 *
 * Основные функции:
 * - Отображает доступные фильтры (селекторы) с возможностью изменения.
 * - Показывает активные фильтры с возможностью их сброса.
 * - При отсутствии результатов, но наличии альтернативных предложений — выводит компонент "Нет результатов".
 *
 * Использует:
 * - Хранилище productSearchStore для получения фильтров, продуктов и мета-данных.
 * - Хук useFilterHandler для обработки фильтров.
 *
 * Возвращает:
 * - JSX блок фильтров и активных фильтров или сообщение о пустых результатах.
 */
const SearchFilterWidget = () => {
    const {filter, metaPagination, products} = useProductSearchStore();
    const {onChangeFilter, onResetFilter} = useFilterHandler()

    const filterState = utilsTypeof.isObject(filter?.state) ? filter.state : {};

    const filtersSelector = utilsTypeof.isObject(filter.selectors) ? filter.selectors : {};

    /**
     *
     * “Условие: скрывать фильтры, если фильтрация дала 0
     * результатов, но при этом в системе вернулись (Альтернативные предложения)”.
     */
    if (metaPagination.count <= 0 && (Array.isArray(products) && !!products?.length)) {
        return (<FilterNotResult onResetFilters={onResetFilter}/>)
    }

    return (
        <StyledSearchFilterWidget className={GLOBAL_STYLE_CONFIG.splitByPrefix('filter')}>
            <ProductFilters filtersSelector={filtersSelector} filterState={filterState} onChangeFilter={onChangeFilter}
                            key={"filter-selectors"}/>
            <ProductFilterSelected onChangeFilter={onChangeFilter} filterState={filterState}
                                   filtersSelector={filtersSelector} countProducts={metaPagination.count}
                                   key={"filter-selected"}
                                   onResetFilters={onResetFilter}
            />
        </StyledSearchFilterWidget>
    );
};

export default SearchFilterWidget;